var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_control"},[_c('a-modal',{attrs:{"visible":_vm.visible,"title":"打印选择","width":"50%","height":"1000px"},on:{"ok":_vm.print,"cancel":function($event){_vm.visible = false}}},[_c('img',{style:(_vm.imgStyle),attrs:{"src":_vm.src,"width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }